var $1e894e47be1bf217$exports = {};
$1e894e47be1bf217$exports = {
    "dismiss": `Opusti`
};


export {$1e894e47be1bf217$exports as default};
//# sourceMappingURL=sl-SI.mjs.map
